import { Component, OnInit, ViewEncapsulation, ElementRef, ViewChild } from '@angular/core';
import { isNumber } from 'lodash';
import { NewHireFullTimeService } from './nhftreport.service';

@Component({
    moduleId: module.id,
    selector: 'nhftreport',
    templateUrl: 'nhftreport.html',
    styleUrls: ['nhftreport.component.css']
})

export class NewHireFullTimeComponent implements OnInit {

    topScrollWidth: number = 2500;
    // selectedYear: string;
    selectedHireMonth: string;
    selectedControlGroup: string[];
    selectedYear: string[];
    selectedMonth: string[];
    eligibleFullTimeWorkers: string = '0';
    errorMessage: string;
    downloadPdfInProgress: boolean = false;
    downloadExcelInProgress: boolean = false;

    // Years: Array<string>;
    // Months: Array<string>;
    // ControlGroups: Array<string>;
    workerDetails: Array<any> = [];

    dataLoaded: boolean;

    public loading = false;
    public rows: Array<any> = [];
    public page: number = 1;
    public itemsPerPage: number = 10;
    public maxSize: number = 5;
    public numPages: number = 1;
    public length: number = 0;

    optionsModel: number[];
    myOptions: any = [];
    myYearOptions: any = [];
    myMonthOptions: any = [];

    @ViewChild('topScroll') topScroll: ElementRef;
    @ViewChild('bottomScroll') bottomScroll: ElementRef;

    public columns: Array<any> = [
        { title: 'Controlled Group', className: 'va-m', name: 'controlGroup' },
        { title: 'Latest Production Company', className: 'va-m', name: 'mostRecentProductionCompany' },
        { title: 'Most Recent Show', className: 'va-m', name: 'mostRecentProject' },
        { title: 'SSN', className: 'hidden-xs va-m', name: 'ssnNumber' },
        { title: 'First Name', className: 'hidden-xs va-m', name: 'firstName' },
        { title: 'Last Name', className: 'va-m', name: 'lastName' },
        { title: 'Email Id', className: 'va-m', name: 'emailId' },
        { title: 'Last Worked Date', className: 'va-m', name: 'lastWorkedDate' },
        { title: 'Hire Date', className: 'va-m', name: 'hireDate' },
        { title: 'Yearly Work End Date', className: 'va-m', name: 'lastWorkDateYearly' },
        { title: 'Union Status', className: 'va-m', name: 'unionType' },
        { title: 'Union Name', className: 'va-m', name: 'unionName' },
        { title: 'Payroll Source', className: 'va-m', name: 'payrollSource' },
        { title: 'ACA Employment Status', className: 'va-m', name: 'employmentStatus' },
        { title: 'Average Hours', className: 'va-m', name: 'avgHours' },
        { title: 'Total Hours', className: 'va-m', name: 'totalHours' },
        { title: 'Resident State', className: 'va-m', name: 'residentState' },
        { title: 'Job Title', className: 'va-m', name: 'jobTitle' },
        { title: 'Employee Type', className: 'va-m', name: 'employeeType' },
        { title: 'Date Of Birth', className: 'va-m', name: 'dateOfBirth' },
        { title: 'Rate Of Pay Unit', className: 'va-m', name: 'rateOfPayUnit' },
        { title: 'Resident Address1', className: 'va-m', name: 'address1' },
        { title: 'Resident Address2', className: 'va-m', name: 'address2' },
        { title: 'City', className: 'va-m', name: 'residentCity' },
        { title: 'State', className: 'va-m', name: 'residentState' },
        { title: 'Country', className: 'va-m', name: 'residentCountry' },
        { title: 'Zipcode', className: 'va-m', name: 'residentZip' },
        { title: 'Employee ID', className: 'va-m', name: 'employeeId' },
        { title: 'Pay Cycle', className: 'va-m', name: 'payCycle' },
        { title: 'Employee Status', className: 'va-m', name: 'employeeStatus' },
    ];
    public config: any = {
        paging: true,
        sorting: { columns: this.columns },
        filtering: { filterString: '' },
        className: ['table', 'table-striped', 'table-bordered', 'table-hover']
    };
    userData: any;
    cgDropdownSettings = {
        singleSelection: false,
        text: 'Select Controlled Group',
    };
    selectedCgValues:any[]
    showfiltererror: boolean = false;
    downloadpdf:any;
    downloadexcel:any;
    selectedYearValues:any = [];
    yearDropdownSettings:any = {
        singleSelection: false,
        text: 'Select Year',
    };
    selectedMonthValues:any = [];
    monthDropdownSettings:any = {
        singleSelection: false,
        text: 'Select Hire Month',
    };
    dropdownSettings = {
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        enableSearchFilter: true,
        classes: 'myclass custom-class',
        badgeShowLimit: 3
    };
    isfilterloaded:boolean = false;
    constructor(private _newHireFullTimeService: NewHireFullTimeService) {
        this.userData = JSON.parse(localStorage.getItem('token'));
    }

    ngOnInit(): void {
        
        if (localStorage.getItem('storedData')) {
            this.onloadData();
        }
        this.setFilterData();
        
        this.eligibleFullTimeWorkers = '0';
        
        this.onChangeTable(this.config);
        this.setDropdownSettings()
        this.reset();
    }
    onloadData(): void {
        const ssnData = JSON.parse(localStorage.getItem('storedData'));
        this.loading = true;
        this._newHireFullTimeService.getSSnData(ssnData).subscribe(workdetails => {
            this.loading = false;
            this.dataLoaded = true;
            this.workerDetails = workdetails;
            this.onChangeTable(this.config);
            // this.topScrollWidth = this.bottomScroll.nativeElement.scrollWidth;
        },
            error => this.errorMessage = <any>error);
    }

    Search(): void {
        this.page = 1;
        this.showfiltererror = false;
        let filterCriteria = this.getFilterValues();
        if(filterCriteria.selectedControlGroup.length === 2){
            this.showfiltererror = true;
            return
        }
        this.isfilterloaded = true;
        this.loading = true;
        filterCriteria.acaEligibleCount = this.eligibleFullTimeWorkers;
        this._newHireFullTimeService.getEligibleFullTimeReportData(filterCriteria).subscribe(workdetails => {
            this.getCount()
            this.loading = false;
            this.dataLoaded = true;
            this.isfilterloaded = false;
            this.workerDetails = workdetails;
            this.onChangeTable(this.config);
        },
            error => this.errorMessage = <any>error);
    }

    reset(): void {
        // this.selectedYear = '-1';
        //this.selectedHireMonth = '-1';
        this.selectedYear = [];
        this.selectedMonth = [];
        this.dataLoaded = false;
        this.eligibleFullTimeWorkers = '0';
        this.showfiltererror = false;
        this.selectedYearValues = [];
        this.selectedMonthValues = [];
        if(this.userData.principal.roles[0] != 'User' || this.userData.principal.controlGroups.length > 1)
        this.selectedCgValues = [];
        this.selectedControlGroup = [];
        }

    getFilterValues(): any {
        // let year = this.selectedYear;
        // if (year === '-1') {
        //     year = '\'\'';
        // }
        // let month = this.selectedHireMonth;
        // if (month === '-1') {
        //     month = '\'\'';
        // }

        //Controlled Group Multi Select
        let cg = this.selectedControlGroup;
        if (cg === undefined) {
            cg = [];
            cg[0] = '\'\'';
            this.selectedControlGroup = [];
        }
        if (cg !== undefined && cg.length <= 0) {
            cg[0] = '\'\'';
            this.selectedControlGroup = [];
        }

        //Year multi select
        let cgYear = this.selectedYear;
        if (cgYear === undefined) {
            cgYear = [];
            cgYear[0] = '\'\'';
            this.selectedYear = [];
        }
        if (cgYear !== undefined && cgYear.length <= 0) {
            cgYear[0] = '\'\'';
            this.selectedYear = [];
        }

        //Month multi select
        let cgMonth = this.selectedMonth;
        if (cgMonth === undefined) {
            cgMonth = [];
            cgMonth[0] = '\'\'';
            this.selectedMonth = [];
        }
        if (cgMonth !== undefined && cgMonth.length <= 0) {
            cgMonth[0] = '\'\'';
            this.selectedMonth = [];
        }

        const filterCriteria: any = {
            selectedYear: cgYear, selectedHireMonth: cgMonth, selectedControlGroup: cg.join(':')
        };
        return filterCriteria;
    }

    getCount(): void {
        let filterCriteria = this.getFilterValues();
        this.eligibleFullTimeWorkers = '0';
        this._newHireFullTimeService.getEligibleFullTimeWorkers(filterCriteria)
            .subscribe(counts => {
                if (counts === undefined || counts == null) {
                    return;
                }
                counts.forEach((element: any) => {
                    this.eligibleFullTimeWorkers = element.acaEligibleCount;
                });
            },
                (error: any) => this.errorMessage = <any>error);
    }


    downloadPdf(): void {
        this.downloadpdf = true;
        let filterCriteria = this.getFilterValues();
            this._newHireFullTimeService.downloadPDFReport(filterCriteria).subscribe((data:any) => {
                this.downloadpdf = false
            }, (err:any) => (this.downloadpdf = false))
    }

    downloadExcel(): void {
        this.downloadexcel = true;
        let filterCriteria = this.getFilterValues();
            this._newHireFullTimeService.downloadExcelReport(filterCriteria).subscribe((data:any) => {
                this.downloadexcel = false
            }, (err:any) => (this.downloadexcel = false))
    }

    public changePage(page: any, data: Array<any> = this.workerDetails): Array<any> {
        let start = (page.page - 1) * page.itemsPerPage;
        let end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;
        return data.slice(start, end);
    }

    public changeSort(data: any, config: any): any {
        if (!config.sorting) {
            return data;
        }

        let columns = this.config.sorting.columns || [];
        let columnName: string = void 0;
        let sort: string = void 0;

        for (let i = 0; i < columns.length; i++) {
            if (columns[i].sort !== '' && columns[i].sort !== false) {
                columnName = columns[i].name;
                sort = columns[i].sort;
            }
        }

        if (!columnName) {
            return data;
        }

        // simple sorting
        return data.sort((previous: any, current: any) => {
            if (previous[columnName] > current[columnName]) {
                return sort === 'desc' ? -1 : 1;
            } else if (previous[columnName] < current[columnName]) {
                return sort === 'asc' ? -1 : 1;
            }
            return 0;
        });
    }

    public changeFilter(data: any, config: any): any {
        let filteredData: Array<any> = data;
        this.columns.forEach((column: any) => {
            if (column.filtering) {
                filteredData = filteredData.filter((item: any) => {
                    return item[column.name].match(column.filtering.filterString, 'i');
                });
            }
        });

        if (!config.filtering) {
            return filteredData;
        }

        if (config.filtering.columnName) {
            return filteredData.filter((item: any) =>
                item[config.filtering.columnName].match(new RegExp(this.config.filtering.filterString, 'i')));
        }

        let tempArray: Array<any> = [];
        filteredData.forEach((item: any) => {
            let flag = false;
            this.columns.forEach((column: any) => {
                if (item[column.name] == null) {
                    item[column.name] = '';
                }
            });
            this.columns.forEach((column: any) => {
                // if (item[column.name] && item[column.name].toString().match(this.config.filtering.filterString)) {
                //     flag = true;
                // }
                if (item[column.name] && !isNumber(item[column.name]) && item[column.name].toLowerCase().match(new RegExp(this.config.filtering.filterString, 'i'))) {
                    flag = true;
                }
                else if (item[column.name] && !isNumber(item[column.name]) && item[column.name].toUpperCase().match(new RegExp(this.config.filtering.filterString, 'i'))) {
                    flag = true;
                }
            });
            if (flag) {
                tempArray.push(item);
            }
        });
        filteredData = tempArray;

        return filteredData;
    }

    public onChangeTable(config: any, page: any = { page: this.page, itemsPerPage: this.itemsPerPage }): any {
        if (config.filtering) {
            Object.assign(this.config.filtering, config.filtering);
        }

        if (config.sorting) {
            Object.assign(this.config.sorting, config.sorting);
        }

        let filteredData = this.changeFilter(this.workerDetails, this.config);
        let sortedData = this.changeSort(filteredData, this.config);
        this.rows = page && config.paging ? this.changePage(page, sortedData) : sortedData;
        this.length = sortedData.length;
    }

    public onCellClick(data: any): any {
        console.log(data);
    }


    arescrolling = 0;
    scroller(from: any, to: any) {
        if (this.arescrolling) return; // avoid potential recursion/inefficiency
        this.arescrolling = 1;
        // set the other div's scroll position equal to ours
        // this.el;
        // debugger;
        from.scrollLeft = to.scrollLeft;
        // document.getElementById(to).scrollLeft =
        //     document.getElementById(from).scrollLeft;
        this.arescrolling = 0;
    }

    ngOnDestroy() {
        localStorage.removeItem('storedData')
    }

    onChangeControlledGroup(){
        this.selectedControlGroup = this.selectedCgValues ? this.selectedCgValues.map((item:any) => item.itemName) : [];
    }

    onChangeYear(){
        this.selectedYear = this.selectedYearValues ? this.selectedYearValues.map((item:any) => item.itemName) : [];
    }

    onChangeMonth(){
        this.selectedMonth = this.selectedMonthValues ? this.selectedMonthValues.map((item:any) => item.itemName) : [];
    }

    setDropdownSettings(){
        Object.assign(this.cgDropdownSettings, this.dropdownSettings);
        Object.assign(this.yearDropdownSettings, this.dropdownSettings);
        Object.assign(this.monthDropdownSettings, this.dropdownSettings);
    }
    setFilterData(){
        this._newHireFullTimeService.getReportData().subscribe(data => {
            this.myYearOptions = data.WorkYear.map((element:any) => {return {id:element,itemName:element}});
            this.myMonthOptions = data.WorkMonth.map((element:any) => {return {id:element,itemName:element}});

            if(this.userData.principal.roles[0] == 'User'){
                if(this.userData.principal.controlGroups.length == 1){
                    this.cgDropdownSettings['disabled'] = true;
                    this.cgDropdownSettings['singleSelection'] = true;
                    this.cgDropdownSettings = Object.assign({}, this.cgDropdownSettings);
                    this.selectedCgValues = [{id:this.userData.principal.controlGroups[0], itemName:this.userData.principal.controlGroups[0]}]
                    this.selectedControlGroup = [this.userData.principal.controlGroups[0]]
                }else{
                    this.myOptions = this.userData.principal.controlGroups.filter((val:any) => data.ControlGroup.includes(val)).map((element:any) => {return {id:element,itemName:element}});
                }
            }else{
                this.myOptions = data.ControlGroup.map((element:any) => {return {id:element,itemName:element}});
            }
        },
            error => this.errorMessage = <any>error);
    }
    onItemSelect() {
        if (this.selectedCgValues.length > 3) {
            this.selectedCgValues.pop();
            // Check if alert already exists to avoid duplicates
            if (!document.getElementById("alertDiv")) {
              const alertDiv = document.createElement('div');
              alertDiv.id = "alertDiv"; // Set an ID to track the alert
              alertDiv.className = 'alert alert-danger alert-dismissible';
              alertDiv.innerHTML = `
                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
                <strong>Error!</strong> You can only select up to 3 control groups.
              `;
              document.body.appendChild(alertDiv);
          
              // Set a timeout to remove the alert after 3 seconds (3000 ms)
              setTimeout(() => {
                const existingAlert = document.getElementById("alertDiv");
                if (existingAlert) {
                  document.body.removeChild(existingAlert);
                }
              }, 3000); // 3000 milliseconds = 3 seconds
            }
          } else {
            // Remove the alert if it exists and selected values are 3 or fewer
            const existingAlert = document.getElementById("alertDiv");
            if (existingAlert) {
              document.body.removeChild(existingAlert);
            }
          }
      }
      
      onItemDeSelect(item: any) {
        // Additional logic on deselect, if needed
      }
}



// WEBPACK FOOTER //
// ./src/app/nhftreport/nhftreport.component.ts